import React from 'react';
import { CSS_VARIABLE_NAMES } from '@/constants';
import { useWindowSize } from './useWindowSize';

const updateVh = () => {
	let heightUpdated = window.innerHeight * 0.01;
	document.documentElement.style.setProperty(
		CSS_VARIABLE_NAMES.VIEWPORT_HEIGHT,
		`${heightUpdated}px`,
	);
};

export function useViewportHeight() {
	const windowSize = useWindowSize();

	// Effects
	React.useEffect(() => {
		updateVh();
	}, [windowSize.width]);
	React.useEffect(() => {
		window.addEventListener('resize', updateVh);

		return () => {
			window.removeEventListener('resize', updateVh);
		};
	}, []);
}
